import { Spinner } from "@merge-api/merge-javascript-shared";
import { Container } from "react-bootstrap";

const FullPageSpinner = () => {
  return (
    <Container fluid className="align-items-center justify-content-center">
      <Spinner />
    </Container>
  );
};

export default FullPageSpinner;
